'use strict';

const helpers = require('../common/helpers');

module.exports = class fp {

	constructor(config) {
		this.config = config;
		this.pathModules = 'fp/';
		this.navbar = document.querySelector('[data-fp="menu"]');
		this.sections = document.querySelectorAll('[data-fp-section]');
		this.boxes = document.querySelectorAll('[data-carousel]');
		this.selectors = {
			activeClass: 'is-active',
			inactiveClass: 'is-inactive',
			hiddenClass: 'is-hidden',
			classMain: '.fp',
			classJour: 'fp__jpj',
			overflow: 'is-overflow',
			infosCircuit: 'caracteristiques',
			overlay: 'has-overlay',
			openMenu: 'has-open-menu'
		};
		this.pdfFT = {
			idContainer: 'formDownloadFT',
			className: 'ft--download',
			form: 'DemandeFiche'
		};
		this.lightboxClasses = {
			bodyOpen: 'lightbox--open',
			placeholder: 'basicLightbox__placeholder'
		}
		this.breakpoint = 1160;
		this.delay = 3000;
	}
	/**
	 *	Méthode appelée dans /Views/Produits/userControl/scripts.ascx
	 *	pour initialiser le js de la FP
	 */
	initialize() {

		/// Block descriptif voyage
		helpers.readMore('', '[data-toggle]', this.selectors.overflow, false, {
			true: 'Lire la suite',
			false: 'Masquer'
		});

		/// Dans les infos du circuit, s'il y a plus de 2 caractéristiques ayant au moins deux items, on hide toutes les box à l'ouverture d'une nouvelle
		document.querySelectorAll(`.${this.selectors.infosCircuit} .box`).length > 1 && helpers.uncheckOthersOnCheck(`.${this.selectors.infosCircuit}`);

		/// Numéro de tel contact
		let btnTels = document.querySelectorAll(`${this.selectors.classMain} a[href^="tel:"]`);
		btnTels.forEach(element => {
			!helpers.isTouchDevice() && helpers.switchTelDesktop(element.id);
		});

		/// Jour par jour : on remove le bouton si descriptif <= 4 lignes
		/// et on masque les jours au-delà de J+3
		this.jpj('#jpj');

		///
		/// Gestions des différents modules : navigation, vidéo, boxes
		this.initModules();

		/// Functions(codeTypeCircuit)
		/// Hide dates
		if (!config.isIndiv && config.hasDate) {
			this.hideNitems('#sectionDates .dates__liste', 6);
		} else if (this.config.codeTypeCircuit === 10) {
			self.config.moduleLiberte.then(() => {
				const lib = require(`${this.pathModules}liberte`);
				let liberte = new lib();
				liberte.initialize();
			}).catch((error) => {
				console.error(error);
			});
		}

		/// Gestionnaire d'événement (Lightbox, jpj)
		const evenement = require(`${this.pathModules}eventActions`);
		let eventActions = new evenement();
		eventActions.initialize();

		if (window.innerWidth < 1300) {
			document.body.classList.add('transparent')
		}
	}

	/**
	 * initModules
	 * @description Chargement et import des modules pour la navigation, les avis et la vidéo
	 */
	initModules() {
		/// Navigation et scroll
		let settingsNav = {
			navbar: this.navbar,
			links: this.navbar.querySelectorAll('ul a'),
			sections: this.sections
		};

		try {
			const nav = require(`${this.pathModules}navigation`);
			let navigation = new nav();
			navigation.initialize(settingsNav);
		} catch (e) {
			console.error(e)
		}

		/// Css
		document.documentElement.classList.add('has-scroll-padding-top');



		// Gérer délpier/replier v3
		document.querySelectorAll('.liste--linking').forEach((el) => {
			if (el.dataset.count !== undefined) {
				if (helpers.offset(el).height > 200) {
					el.classList.add('has-only-first-items-line-showed');
				} else {
					el.nextElementSibling.remove();
					el.classList.add('has-all-items-showed');
				}
			}
		})
		// V3 Fil d'ariane #18257
		var nav = priorityNav.init({
			mainNavWrapper: '.fp__ariane',
			navDropdownLabel: '+',
			breakPoint: 0
		});

		// Si la longueur totale des items est > à la largeur affichée, on affiche le bouton
		// Sinon on ne fait rien
		this.boxes.forEach(el => {
			let carouselModule = require('modules/carousel'),
				carousel = new carouselModule(config);
			carousel.initialize(el.dataset.carousel);
		})

		if (!helpers.isTouchDevice()) {
			let snapModule = require('modules/snap');
			let snap = new snapModule();
			snap.carousel('[data-snap="tourismeResponsable"]');
		}

		if (typeof HTMLDialogElement == 'function') {
			// Dialog modules (infos circuit)
			let dialogModule = require('common/dialog'),
				dialogInfosCircuit = new dialogModule();
			dialogInfosCircuit.initialize();
		} else {
			let btnsDialog = document.querySelectorAll('[data-dialog-btn] > svg[width="12"]');
			btnsDialog.forEach(el => el.remove())
		}

		// Gérer l'affichage de la V2
		if (helpers.getWindowWidth() <= 1024) {
			if (!this.config.hasPrix.indiv || !this.config.hasPrix.gir) {
				setTimeout(() => {
					document.body.style.setProperty('--heightBlockTravel', document.querySelector('.fp__travel').getBoundingClientRect().height + "px");
				}, 100);
			} else {
				document.body.style.setProperty('--heightBlockTravel', document.querySelector('.fp__travel').getBoundingClientRect().height + "px");
			}

		} else {
			setTimeout(() => {
				[...document.querySelectorAll('.caracteristiques > *')].filter((el, index) => index < 2 && el.remove())
			}, 100);
		}
	}

	/**
	 * hideNitems
	 *
	 * @description Pour un block html donné, on masque les items dont l'index est > n. Au click sur l'élément adjacent, on affiche toute la liste et on supprime l'élément
	 * @param blockSelector block html dont on masque les items
	 * @param n int représentant l'index au-delà duquel on souhaite masquer la suite
	 *
	 */
	hideNitems(blockSelector, n) {
		let block = document.querySelector(blockSelector);
		if (parseInt(block.dataset.nombreItems) > n) {
			block.dataset.hide = true;
			let allItemsShow = false;
			block.nextElementSibling.addEventListener('click', (e) => {
				if (!allItemsShow) {
					block.dataset.hide = false;
					e.target.querySelector('span').innerText = e.target.dataset.libelleHide;
					e.target.querySelector('use').setAttribute('xlink:href', '#picto-fp-moins');

				} else {
					block.dataset.hide = true;
					block.scrollIntoView({
						behavior: 'smooth',
						inline: 'start'
					});
					e.target.querySelector('span').innerText = e.target.dataset.libelleShow;
					e.target.querySelector('use').setAttribute('xlink:href', '#picto-fp-plus');
				}
				allItemsShow = !allItemsShow;
			})
		}
	}


	/**
	 *	Jour par jour
	 *  @description On masque les jours au-delà de J+3 & on remove les boutons si descriptif court
	 *
	 */
	jpj(id) {
		/// Hide days
		this.hideNitems(id, 3);
	}

	/**
	 * getPromiseHtml
	 *
	 * @description Helper : lors d'un fetch, on récupère directement la valeur de la promesse
	 * @param options Optionnel permet de paramètrer la méthode GET|POST, les headers et les data et le format d'envoi
	 */
	getPromiseHtml(url, options) {
		return new Promise(async function (resolve, reject) {
			const res = await fetch(url, options)
			resolve(res.text());
			reject(res);
		})
	}

	_demandeFT(containerLightbox) {
		let formulaire = document.getElementById(this.pdfFT.form),
			self = this,
			container = document.getElementById(this.pdfFT.idContainer),
			lightboxFt = document.querySelector(containerLightbox);


		// on charge l'event blur sur le champs mail pour afficher ou non le block d'optin
		var formClass = new Formulaire();
		var emailInput = document.getElementById("Email");
		emailInput.addEventListener('blur', () => {
			formClass._afficherOptinNL(emailInput);
		});

		formulaire.addEventListener('submit', (e) => {
			e.preventDefault();
			let formData = new URLSearchParams(new FormData(e.target)),
				regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

			if (formData.get('Email') !== '' && regex.test(formData.get('Email'))) {

				formClass._saveOptinNL(formulaire);
				self.getPromiseHtml(e.target.action, {
					method: 'POST',
					body: formData // event.target is the form
				}).then((reponse) => {
					container.innerHTML = reponse;
					setTimeout(function () {
						container.remove();
						if (lightboxFt !== null) {
							lightboxFt.classList.remove('has-open-menu');
						} else {
							delete document.body.dataset.popin;
							document.body.classList.remove('has-overlay');
							document.body.style.removeProperty('overflow');
						}
					}, self.delay);
					let obj = {
						id: this.pdfFT.form,
						email: formData.get('Email'),
						libelle: 'demande FT'
					}
					return obj;
				}).
				then((obj) => {
						helpers._dispatchEventSubmitForm(obj, this.selectors.classMain);
					})
					.catch((error) => {
						console.error(error)
					});
			} else if (!regex.test(formData.get('Email')) && !helpers.elementExist('#DemandeFiche .field-validation-error')) {
				let p = document.createElement('p');
				p.classList.add('field-validation-error')
				p.textContent = `${formData.get('Email')} n'est pas un email valide`;
				document.getElementById('DemandeFiche').querySelector('.field').after(p)
			}
		})
	}

	downloadFT(target, container) {
		let self = this,
			url = `${target.dataset.download}${config.codeProduct}`;

		self.getPromiseHtml(url)
			.then((data) => {
				document.body.classList.add('has-overlay');
				const tmp = document.createElement('div')
				tmp.innerHTML = data;
				tmp.id = this.pdfFT.idContainer;
				tmp.className = this.pdfFT.className;
				let where = target.dataset.parent === 'aside' ? 'afterend' : 'afterbegin';
				target.parentElement.insertAdjacentElement(where, tmp);
				if (target.dataset.parent === 'aside') {
					document.body.dataset.popin = 'demandeFt';
					document.body.style.overflow = 'hidden';
				}
				return target.dataset.parent;
			})
			.then((info) => {
				if (helpers.isTouchDevice() && info === 'aside') {
					document.getElementById('formDownloadFT').scrollIntoView();
				}
				self._demandeFT(container)
			})
	}
}